<template>
    <transition name="slide-up">
        <div v-if="products && products.length > 0" class="compare-bar boxed-item rounded-0">

            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <carousel :perPageCustom="[[0, 1], [960, 2]]" :paginationEnabled="false" :navigationEnabled="true">

                            <slide class="w-50 container" v-for="(item, key) in products" v-bind:key="key">
                                <div class="row justify-content-center">
                                    <div  class="col-md-12 justify-content-center text-center">
                                        <div class="item row">
                                            <div class="image-container col-2">
                                                <img class="main-image" v-bind:src="item.ImageUrl" />
                                                <i class="fa fa-circle-o-notch fa-spin mt-3" v-if="!item.ImageUrl"></i>
                                            </div>
                                            <div class="text-container col-9 text-left">
                                                <a v-bind:href="'/products/'+item.Slug" class="product-title"> {{ item.Title }} </a>
                                            </div>
                                            <div class="remove-container col-1">
                                                <button v-on:click="removeProduct(key)" v-bind:disabled="loading" type="button" class="btn btn-link">
                                                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </slide>

                        </carousel>
                    </div>

                    <div v-if="products.length > 1" class="col-12 col-lg-4 justify-content-center text-center button-container">
                        <a v-bind:class="{disabled: loading}" v-bind:href="'/compare/'+skuUrl" class="btn btn-primary"> {{products.length}} producten vergelijken </a>
                        <button v-bind:disabled="loading" v-on:click="removeAllProducts(products)" class="text-white btn btn btn-dark"><i class="fa fa-trash" aria-hidden="true"></i></button>
                    </div>
                    <div v-if="products.length <= 1" class="col-12 col-lg-4 justify-content-center text-center button-container">
                        <button disabled="true" v-bind:href="'/compare/'+skuUrl" class="btn btn-primary">Voeg nog 1 product toe om te vergelijken </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import { Carousel, Slide } from 'vue-carousel';

    export default {

        components: {
            Carousel,
            Slide
        },

        data() {
            return {
                products: [],
                skuUrl: '',
                loading: false
            }
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {

                this.getProducts();

                bus.$on('compare:loading', function () {
                    this.loading = true;
                }.bind(this));

                bus.$on('compare:loaded', function (products) {
                    if (products) {
                        this.products = products.slice().reverse();
                        this.buildCompareUrl(this.products);
                    }
                    this.loading = false;
                }.bind(this));

                bus.$on('removeCompareItem', function (key) {
                    this.products.reverse();
                    delete this.products[key]['ImageUrl'];
                    this.products.reverse();
                }.bind(this));

            },

            /**
             * Get products from service
             */
            getProducts() {
                this.products = window.CompareService.getProducts();
            },

            /**
             * Build Sku from product and add to url
             * @param products
             */
            buildCompareUrl(products) {
                let arrayUrl = [];
                products.forEach(function (product) {
                    arrayUrl.push(product.Sku);
                });
                this.skuUrl = arrayUrl.join(";");

            },

            /**
             * Remove product from compare bar
             * @param sku
             */
            removeProduct(key) {
                if (typeof this.products[key] !== 'undefined') {
                    let product = this.products[key];
                    window.CompareService.removeProduct(product.Sku);
                }
            },

            /**
             * Remove all products from compare bar
             * @param products
             */
            removeAllProducts(products) {
                if (confirm('Weet u zeker dat u al uw producten uit de vergelijking wilt verwijderen?')) {
                    window.CompareService.removeAllProducts(products);
                    this.products = [];
                }
            }
        }
    }
</script>
